'use client'

import { Box, Container, Heading, Stack, Image, Link } from '@chakra-ui/react'
import Footer from '@/components/landing-page/footer'

export default function CreatorGuidePage() {
  const guides = [
    {
      title: 'Watch-Time Monetization Guide',
      image: '/creators-page/watch-time-guide.jpg',
      link: '/creator-guide/watch-time-monetization'
    },
    {
      title: 'Video Platforms Comparison',
      image: '/creators-page/platform-comparison.jpg',
      link: '/creator-guide/video-platforms-compared'
    },
    {
      title: 'India Creator Guide',
      image: '/creators-page/india-creator-guide.jpg',
      link: '/creator-guide/video-creator-india'
    }
  ]

  return (
    <Box bg="white">
      <Container maxW="1100px" py={16} color={"#3E3E3E"}>

        {/* PAGE TITLE */}
        <h1 style={{
          fontSize: '2.25rem',
          fontWeight: 'bold',
          marginBottom: '2rem',
          color: '#3E3E3E',
          lineHeight: '1.2'
        }}>
          Creator Guides
        </h1>

        {/* POSTER STACK */}
        <Stack spacing={8}>

          {guides.map((guide, index) => (
            <Link
              key={index}
              href={guide.link}
              _hover={{ textDecoration: 'none' }}
            >
              <Box
                borderRadius="2xl"
                overflow="hidden"
                boxShadow="lg"
                transition="all 0.3s ease"
                _hover={{
                  transform: 'scale(1.02)',
                  boxShadow: '2xl'
                }}
              >
                <Image
                  src={guide.image}
                  alt={guide.title}
                  width="100%"
                  height="auto"
                />
              </Box>
            </Link>
          ))}

        </Stack>

      </Container>

      <Footer />
    </Box>
  )
}